export default __webpack_public_path__ + "static/media/ktp salah.9acff1e7.jpg";